// traceCapability - choosing a grammar for each shell call, and how many calls
// one trace reads.
//
// WHICH calls are shell calls is the action table's answer (traceActions), so
// the capability pass and the work router read the same list.
//

// A trace is a whole conversation and every shell call costs a parse. The cap
// is high enough for any real session and keeps a pathological one from
// pinning the tab; what is dropped is REPORTED rather than silently missing,
// because a reach band that quietly stopped covering the tail would be worse
// than no band.
export const MAX_SHELL_CALLS = 2_000;

// PowerShell spelled through a generic shell tool. Windows endpoints run it
// through the same tool name as bash, so the tool name alone cannot decide the
// grammar, and parsing PowerShell as bash produces a tree that is wrong rather
// than one that fails. A cmdlet at command position, a PowerShell-only
// variable form, or a common parameter is decisive; nothing else is.
const POWERSHELL_HINT = new RegExp([
  "(?:^|[\\n;|(]\\s*)(?:Get|Set|New|Remove|Invoke|Select|Where|Test|Out|Write|Add|Clear|Copy|Move|Start|Stop|Import|Export|ConvertTo|ConvertFrom|Measure|Sort|Format|Join|Split)-[A-Z][A-Za-z]+",
  "\\$env:",
  "\\$PSVersionTable",
  "\\s-(?:ErrorAction|WarningAction|Recurse|Force|Path)\\b",
].join("|"));

const POWERSHELL_TOOLS = /^(?:powershell|pwsh)$/i;

/** Which grammar a captured command should be read with. */
export function detectShellLanguage(toolName, command) {
  if (POWERSHELL_TOOLS.test(String(toolName || ""))) return "powershell";
  return POWERSHELL_HINT.test(String(command || "")) ? "powershell" : "bash";
}
